import { useState, useCallback } from "react";

const buildRequestUrl = (url = "") => {
  if (/^https?:\/\//i.test(url)) {
    return url;
  }

  return url.startsWith("/") ? url : `/${url}`;
};

const useHttp = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const sendRequest = useCallback(async (requestConfig, applyData) => {
    setIsLoading(true);
    setError(null);
    
    const fullUrl = buildRequestUrl(requestConfig.url);
    console.log(`Making ${requestConfig.method} request to:`, fullUrl);
    
    try {
      const response = await fetch(
        fullUrl,
        {
          method: requestConfig.method,
          headers: {
            "Content-Type": "application/json",
            ...requestConfig.headers, // Merge any additional headers
          },
          body: JSON.stringify(requestConfig.body),
          mode: "cors",
        }
      );

      console.log(`Response status: ${response.status} ${response.statusText}`);

      if (!response.ok) {
        throw new Error(`Request failed: ${response.status} ${response.statusText}`);
      }

      const data = await response.json();
      console.log('Response data:', data);
      applyData(data);
    } catch (err) {
      console.error('Request error:', err);
      const errorMessage = err.message || "Something went wrong!";
      setError(errorMessage);
      applyData(errorMessage);
    }
    setIsLoading(false);
  }, []);

  return {
    isLoading,
    error,
    sendRequest,
  };
};

export default useHttp;
